import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

export const DemReconChannelDiscrepanciesChart = ({ prodIds }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  const { navigateTo } = useNavState();

  useEffect(() => {
    const params = { prodIds, groupByChannel: true };
    rsrc.data('gtn', 'RECON_OPEN_PERIOD_DISCREPANCIES_DATA_PLUGIN', params).then(res => {
      setData(res);
    });
  }, [prodIds]);

  const theme = useTheme();

  if (!data) return null;

  const reconciledSeries = data.series.find(series => series.label === 'Reconciled');
  reconciledSeries.color = theme.palette.success.main;

  const outstandingSeries = data.series.find(series => series.label === 'Outstanding');
  outstandingSeries.color = theme.palette.error.main;

  const handleClick = (clickData) => {
    const channelId = data.channelMap[clickData.category];

    navigateTo('gtn/recon', {
      mode: Mode.PERSPECTIVE,
      filterButtons: {
        discrepancy: 1
      },
      perspectiveState: {
        dimFilters: {
          CHANNEL: [channelId],
          PROD: prodIds,
        },
      },
    });
  }

  return (
    <CartesianChart
      data={data}
      horizontal
      stacked
      onClick={handleClick}
    />
  );
};